import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import MediaPanel from '../../../../components/Editor/EditPanel/MediaPanel';
import { EditorType } from '../../constants';

interface MediaPanelOwnProps {
	page: number;
}

const mapStateToProps = (state: StoreState, { page }: MediaPanelOwnProps) => {
	const {
		editor: {
			type: editorType,
			activeItem: { id },
			editableMedia,
		},
		importManager: { byId },
	} = state;

	const {
		label,
		defaultLink,
		driveLink,
		externalLink,
		isExternalLinkActive,
		frameWidth,
		frameHeight,
		importManagerId,
	} = editableMedia[page][id];

	return {
		page,
		id,
		label,
		defaultLink,
		driveLink,
		externalLink,
		isExternalLinkActive,
		frameWidth,
		frameHeight,
		importManagerId,
		isImporting: !!byId[importManagerId],
		isPercentageValues: editorType === EditorType.HTML,
	};
};

export default connect(mapStateToProps)(MediaPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/MediaPanel/index.tsx